import React from 'react';
import ReactDOM from 'react-dom/client';
import '../../header';
import '../../navigation';
import '../../share-profile';
import { initCartComponent } from '../../cart';
import AthleteShop from './pages/AthleteShop';
import './index.css';
import './legacy-builder.css';
import './athlete-shop.css';

initCartComponent();

function initProductLinkNavigation() {
    const productLinks = document.querySelectorAll('a.product-card');
    productLinks.forEach(function(link) {
        link.addEventListener('click', function() {
            sessionStorage.setItem('nav-direction', 'forward');
        });
    });
}

function initShopComponent() {
    const shopRoot = document.getElementById('shop-root');
    const shopDataEl = document.getElementById('shopData');

    if (shopRoot && shopDataEl) {
        const shopData = JSON.parse(shopDataEl.textContent || '{}');
        const root = ReactDOM.createRoot(shopRoot);
        root.render(React.createElement(AthleteShop, {
            athleteInfo: shopData.athleteInfo,
            brands: shopData.brands,
            capsules: shopData.capsules || [],
            products: shopData.products,
            socials: shopData.socials
        }));
        // Set up navigation after render
        setTimeout(() => {
            initProductLinkNavigation();
        }, 0);
    }
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initShopComponent);
} else {
    initShopComponent();
}

if (module.hot) { module.hot.accept(); }
